import { type StopType } from '../domain/StopType'

export function getStopTypeLabel(stopType: StopType): string {
  switch (stopType) {
    case 'pickup':
      return 'Pickup'
    case 'stop':
      return 'Stop'
    case 'delivery':
      return 'Delivery'
  }
}
